export default __webpack_public_path__ + "images/2e996e26b578d486370b8f6307987dec-nightlife_tablet.webp";